/**
 * Checks if event is a right click event
 *
 * @param {DOMEvent} nativeEvent DOM event
 * @returns {boolean} is right click event
 */
export default function isRightClick(nativeEvent) {
  if ('which' in nativeEvent && nativeEvent.which === 3) {
    return 'button' in nativeEvent && nativeEvent.button === 2;
  }

  return false;
}
